import { useLang } from "@/i18n";
import { IMG, OFFICIAL } from "@/data/media";
import { L } from "@/components/L";

const NAV = ["about", "activities", "projects", "team", "gallery", "donate", "contact"];

export default function Footer() {
  const { t } = useLang();
  const reopenCookies = () => window.dispatchEvent(new Event("made:cookie-open"));
  return (
    <footer className="relative bg-[var(--green-night)] text-white overflow-hidden" data-testid="site-footer">
      <div aria-hidden="true" className="absolute -right-24 -top-24 w-56 h-56 petal-bl bg-[var(--green-deep)] opacity-60" />
      <div className="wrap relative pt-20 pb-10">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4">
              <span className="bg-white rounded-[1.5rem_1.5rem_1.5rem_0] p-3"><img src={IMG.logo} alt="Logo MADE" className="h-16 w-auto" width="52" height="68" loading="lazy" /></span>
              <div>
                <p className="font-display text-2xl">Fundación MADE</p>
                <p className="text-xs uppercase tracking-[0.2em] text-white/75 mt-1">MADE ONLUS</p>
              </div>
            </div>
            <p className="font-display italic text-2xl sm:text-3xl mt-8 max-w-md leading-snug" data-testid="footer-tagline">{t.footer.tagline}</p>
          </div>
          <div className="lg:col-span-2">
            <p className="text-xs uppercase tracking-[0.2em] text-[var(--yellow)] mb-4">{t.footer.navTitle}</p>
            <ul className="space-y-2.5 text-white/85">
              {NAV.map((k) => <li key={k}><L to={k} className="link-u hover:text-white" data-testid={`footer-nav-${k}`}>{t.nav[k]}</L></li>)}
            </ul>
          </div>
          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-[var(--yellow)] mb-4">{t.footer.contactTitle}</p>
            <address className="not-italic space-y-2.5 text-white/85 text-[15px]">
              <p>MADE ONLUS<br />{OFFICIAL.address}</p>
              <p>{t.contact.faxLabel}: <a className="link-u" href={`fax:${OFFICIAL.faxHref}`}>{OFFICIAL.fax}</a></p>
              <p><a className="link-u break-all" href={`mailto:${OFFICIAL.email}`} data-testid="footer-email">{OFFICIAL.email}</a></p>
            </address>
          </div>
          <div className="lg:col-span-2">
            <p className="text-xs uppercase tracking-[0.2em] text-[var(--yellow)] mb-4">{t.footer.donateTitle}</p>
            <p className="text-white/85 text-[15px]">{t.donate.cfLabel}<br /><span className="font-semibold tracking-wider">{OFFICIAL.cf}</span></p>
            <L to="donate" className="btn btn-yellow mt-5 !py-3" data-testid="footer-donate-btn">{t.nav.donateNow}</L>
          </div>
        </div>
        <div className="mt-16 pt-6 border-t border-white/15 flex flex-col md:flex-row gap-4 md:items-center md:justify-between text-sm text-white/75">
          <p>© {new Date().getFullYear()} MADE ONLUS · C.F. {OFFICIAL.cf} · {t.footer.rights}</p>
          <p className="text-white/70">{t.footer.photos}</p>
          <div className="flex gap-5">
            <L to="privacy" className="link-u" data-testid="footer-privacy-link">{t.footer.privacy}</L>
            <L to="cookies" className="link-u" data-testid="footer-cookie-link">{t.footer.cookies}</L>
            <button onClick={reopenCookies} className="link-u" data-testid="footer-cookie-settings">{t.footer.cookieSettings}</button>
          </div>
        </div>
      </div>
    </footer>
  );
}
